import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Landing from "@/pages/Landing";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Policies from "@/pages/Policies";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/success" element={<Success />} />
            <Route path="/policies" element={<Policies />} />
          </Routes>
          <Toaster theme="dark" position="bottom-center" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
